import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';

export const accountSelector = (state: RootState) => state.account.account;
export const activeGroupNameSelector = (state: RootState) => state.account.selectedGroupName;

// Memoized selector - JSON.parse only runs when incidentSettings changes
const selectIncidentSettings = (state: RootState) => state.account.incidentSettings;
export const accountIncidentSelector = createSelector(
  [selectIncidentSettings],
  (incidentSettings) =>
    incidentSettings?.pvSettingValue
      ? JSON.parse(incidentSettings.pvSettingValue)
      : []
);
export const activeGroupSelector = (state: RootState) => state.account.selectedGroup;
export const palmettoGroupsSelector = (state: RootState) => state.account.allGroups;
export const programsPermissionsSelector = (state: RootState) => state.account.programsPermissions;
export const dashboardSettingsSelector = (state: RootState) => state.account.dashboardSettings;
export const hasFetchedDashboardSettingsSelector = (state: RootState) =>
  state.account.hasFetchedDashboardSettings;
